import {ChangeDetectorRef, Component, ElementRef, signal} from "@angular/core";
import {FUIAbstractPop, PopParentHorizontalAlignment, PopParentVerticalAlignment} from "../../../pops/abstract-pop";
import {FUIPopsService} from "../../../pops/pops.service";
import {FUIFormContext} from "../../../form-context/form-context";
import {FUIPopFormContext} from "../../../form-context/pop-form-context";
import {FUIResponsiveService} from "../../../page/responsive.service";
import {FUIEventsService} from "../../../events/events.service";

@Component({
    providers: [{ provide: FUIFormContext, useClass: FUIPopFormContext }],
    selector: "fui-time-pop",
    styleUrls: ["./time-pop.component.scss"],
    templateUrl: "./time-pop.component.html",
    standalone: false
})
export class FUITimePopComponent extends FUIAbstractPop {
    parentHorizontalAlignment = signal<PopParentHorizontalAlignment>(PopParentHorizontalAlignment.LEFT);
    parentVerticalAlignment = signal<PopParentVerticalAlignment>(PopParentVerticalAlignment.DYNAMIC);
    limitWidthToParent: boolean = false;
    adjustHeightToFirstElement: boolean = false;

    constructor(eventsService: FUIEventsService,
                changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                popsService: FUIPopsService,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, elementRef, eventsService, popsService, responsiveService);
    }
}
